import {
  UPDATE_LOCATION,
  UPDATE_LOCATION_SUCCESS,
  UPDATE_LOCATION_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const updateLocationReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_LOCATION:
      return { ...state, loading: true };
    case UPDATE_LOCATION_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case UPDATE_LOCATION_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default updateLocationReducer;
